<template>
<el-container>
  <el-main>
    <el-table
      :data="tableData"
      border
      style="width: 100%;"
      @row-dblclick="rowdbclk"
    >
      <el-table-column
        prop="sid"
        label="序号"
        width="60"
        v-if="false"
      >
      </el-table-column>
      <el-table-column
        prop="sdept"
        label="部门"
        width="100"
      >
      </el-table-column>
      <el-table-column
        prop="sname"
        label="姓名"
        width="100"
      >
      </el-table-column>
   <el-table-column label="登录/退出" width="100">
        <template slot-scope="scope">
         <el-checkbox  v-model="scope.row.blogin"></el-checkbox>
        </template>
      </el-table-column>
   <el-table-column label="运营管理" width="100">
        <template slot-scope="scope">
         <el-checkbox  v-model="scope.row.byygl"></el-checkbox>
        </template>
      </el-table-column>
   <el-table-column label="客户管理" width="100">
        <template slot-scope="scope">
         <el-checkbox  v-model="scope.row.bkhgl"></el-checkbox>
        </template>
      </el-table-column>
   <el-table-column label="订单管理" width="100">
        <template slot-scope="scope">
         <el-checkbox  v-model="scope.row.bddgl"></el-checkbox>
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="操作"
        width="100"
      >
        <template slot-scope="scope">
          <el-button
            @click="restpassword(scope.row)"
            type="text"
            size="small"
          >重置密码</el-button>
        </template>
      </el-table-column>

    </el-table>
      

  </el-main>
  <el-footer>
       <el-button >提交</el-button>
       <el-button >重置</el-button>

  </el-footer>
</el-container>

</template>

<script>
import axios from "axios";
import Qs from "qs";
import global from "../global.vue";
const smodel = "9jzsftbxx";

export default {
  created() {
    this.getParams();
    this.delandgetdata();
  },
  mounted() {
    this.mypageinit();
  },
  methods: {
    getdata() {
      this.slogid = window.localStorage.getItem("sloginid");
      //stoken = AES.decrypt(stoken,global.AEScode);
      let that = this;
      axios({
        method: "get",
        url: global.sserverip + "get" + smodel,
        //url: "http://172.18.0.141:8081/get7jnzdr",
        params: { sid: that.sfilter }
      })
        .then(function(res) {
          //TO-DO 先判断下数据是否正确 status
          that.tableData = res.data;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
  },
  data() {
    return {
      slogid: "",
      sfilter:"",
      bedit: true,
      bbrow: false,
      tableData: [
         {
          sid: "1",
          sdept: "出口部",
          sname: "张三",
          blogin: true,
          byygl: true,
          bkhgl: false,
          bddgl: true,
        },
        {
          sid: "2",
          sdept: "出口部",
          sname: "李四",
          blogin: true,
          byygl: false,
          bkhgl: true,
          bddgl: false,
        }

      ]
    };
  }
};
</script>


